// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------
import { createEnum } from "@cartographerio/util";
const SmoothTransition = "ST";
const MarshCliff = "MC";
const MarshRamp = "MR";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const MrsMorphEstuariesMarginTypeEnum = {
    ...createEnum("MrsMorphEstuariesMarginType", [
        [SmoothTransition, "Smooth transition"],
        [MarshCliff, "Marsh cliff"],
        [MarshRamp, "Marsh ramp"],
    ]),
    SmoothTransition,
    MarshCliff,
    MarshRamp,
};
null;
null;
export default MrsMorphEstuariesMarginTypeEnum;
//# sourceMappingURL=MrsMorphEstuariesMarginTypeEnum.generated.js.map